import styled from 'styled-components';
import ArrowDown from '../../../assests/images/linear-arrow-down.svg';

export const CausePreferencesSection = styled.div`

`;

export const FundraiserTitle = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:40px;
    font-weight: bold;
    line-height: 58px;
    margin-bottom: 12px;  
    		 
    @media screen and (max-width:1199px) {
        font-size: 35px;
        line-height: 40px;
    }
    @media screen and (max-width:991px) {
        font-size: 30px;
        line-height: 35px;
    }
    @media screen and (max-width:575px) {
        font-size: 28px;
        line-height: 40px;
        margin-bottom: 20px;
    }   
`;

export const CauseSmallText = styled.p`
    color: #000000;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    margin-bottom: 30px; 
`;

export const CausePreferencesFrom = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding:20px;
    max-width: 996px;
    width:100%;
    margin: 0 auto;

    .form-label{
        color: #000000;
        font-family: "Jost", sans-serif;
        font-size:16px;
        font-weight: 500;
        line-height: 23px;
        margin-bottom: 10px; 
    }

    .form-select{
        color: rgb(0 0 0 / 50%);
        font-size: 16px;
        line-height: 21px;
        font-family: "Jost", sans-serif;
        background-color: #0000000D;
        border: 1px solid #0000000D;
        border-radius: 10px;
        height: 50px;
        background-size: 24px;
        background-image:url(${ArrowDown});
        margin-bottom: 20px;

        &:focus{
            box-shadow:none;
            border-color: #86b7fe;
        }
    }
`;

export const FromButton = styled.div`
    display: flex;
    justify-content: center;
    gap: 15px;

    @media screen and (max-width: 420px){
        flex-direction: column;
        row-gap: 15px;
    }
    
    .btn-outline-success-blue{
        padding: 12px 30px;
        @media screen and (max-width:575px) {
            padding: 10px 20px;
        }
    }
    
    .btn-outline{
        background: #fff;
        color: #01606F;
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        padding: 10px 51px;
        transition: all 0.5s;
        border-radius: 10px;
        box-shadow: 0px 5px 20px #0000001A;
        border: 1px solid #01606F;
        border-radius: 10px;
        &:hover{
            background: #FFD495 !important;
            color: #333333 !important;
            transition: all 0.5s;
            border: 1px solid #FFD495;
        } 
        @media screen and (max-width:575px) {
            padding: 10px 40px;
        }
    }
`;